import { render, staticRenderFns } from "./FinishGroupClassConfirmationDialog.vue?vue&type=template&id=57c3dfaa"
import script from "./FinishGroupClassConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./FinishGroupClassConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports